import React from 'react';
import PropTypes from 'prop-types';

const ListViewIcon = ({ className }) => (
  <svg
    className={className}
    width="56"
    height="53"
    viewBox="0 0 56 53"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1"
      y="1"
      width="53.3131"
      height="50.3499"
      rx="1"
      fill="white"
      stroke="#1E1E1E"
      strokeWidth="2"
    />
    <rect x="14" y="14" width="9.6" height="6.4" rx="2" fill="#1E1E1E" />
    <rect x="14" y="22.8" width="9.6" height="6.4" rx="2" fill="#1E1E1E" />
    <rect x="14" y="31.5996" width="9.6" height="6.4" rx="2" fill="#1E1E1E" />
    <rect x="26" y="14.8" width="15.2" height="2.4" rx="1.2" fill="#1E1E1E" />
    <rect x="26" y="23.5996" width="15.2" height="2.4" rx="1.2" fill="#1E1E1E" />
    <rect x="26" y="32.4004" width="15.2" height="2.4" rx="1.2" fill="#1E1E1E" />
  </svg>
);

ListViewIcon.propTypes = {
  className: PropTypes.string
};

export default ListViewIcon;
